export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";
export const LOGOUT = "LOGOUT";

export const ADD_TASK_LIST = "ADD_TASK_LIST";
export const DELETE_TASK_LIST = "DELETE_TASK_LIST";
export const ADD_TASK = "ADD_TASK";
export const DELETE_TASK = "DELETE_TASK";
export const TOGGLE_COMPLETED_TASK = "TOGGLE_COMPLETED_TASK";
export const UPDATE_TASK_NAME = "UPDATE_TASK_NAME";
export const UPDATE_TASK_DETAILS = "UPDATE_TASK_DETAILS";
export const UPDATE_TASK_DATE = "UPDATE_TASK_DATE";
